angular.module('gym.bulkUpdates').controller('BulkUpdatesListCtrl', ["$scope", "$rootScope", "$state", "$window", "$http", "loadingAnimation", "ngTableParams", "AdminUserService", "flash", function($scope, $rootScope, $state, $window, $http, loadingAnimation, ngTableParams, AdminUserService, flash) {
  var baseUrl, gym;
  if (!AdminUserService.has('admin_perform_bulk_record_updates')) {
    $state.go('gym.dashboard');
  }
  gym = $rootScope.gym;
  baseUrl = `/gyms/${gym.id}/bulk_update/bulk_updates`;
  $scope.tableParams = new ngTableParams({
    page: 1,
    count: 10
  }, {
    counts: [],
    total: 0,
    getData: function($defer, $params) {
      loadingAnimation.show();
      return $http.get(baseUrl, {
        params: $params.url()
      }).then(function(response) {
        $params.total(response.data.total);
        $defer.resolve(response.data.collection);
        return loadingAnimation.hide();
      });
    }
  });
  $scope.createUpdate = function(type) {
    var params;
    params = {
      bulk_record_update: {
        update_type: type
      }
    };
    return $http.post(baseUrl, params).then(function(response) {
      return $state.go('gym.bulkUpdates.show', {
        id: response.data.id
      });
    }, function(response) {
      var ref, ref1;
      return flash.error = ((ref = response.data.errors) != null ? (ref1 = ref.status) != null ? ref1[0] : void 0 : void 0) || "Request could not be completed. Please try again";
    });
  };
  return $scope.delete = function(item) {
    var url;
    if ($window.confirm('This will permanently remove the selected bulk update. Are you sure?')) {
      url = `${baseUrl}/${item.id}`;
      return $http.delete(url).then(function() {
        return $scope.tableParams.reload();
      });
    }
  };
}]);
